import { render, staticRenderFns } from "./emailVerification.vue?vue&type=template&id=aa74b30a&scoped=true&"
import script from "./emailVerification.vue?vue&type=script&lang=js&"
export * from "./emailVerification.vue?vue&type=script&lang=js&"
import style0 from "./emailVerification.vue?vue&type=style&index=0&id=aa74b30a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74b30a",
  null
  
)

export default component.exports